<template>
	<div class="video-player-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div class="video-container">
			<div v-if="fieldOptions.streaming_service_type === STREAMING_SERVICES_TYPES.YOUTUBE">
				<iframe :src="videoSrc" id="ytplayer" type="text/html" width="100%" height="auto" frameborder="0" />
			</div>
			<div v-else-if="videoSrc">
				<iframe
					frameborder="0"
					:src="videoSrc"
					allowfullscreen
					mozallowfullscreen
					webkitallowfullscreen
					style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from '../WidgetFieldMixin';
import DefaultWidgetField from '../DefaultWidgetField';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';
import { STREAMING_SERVICES_TYPES } from '../../FieldSettings/VideoPlayerFieldSettings/VideoPlayerField.const';

export default {
	name: 'VideoPlayerField',
	data() {
		return { STREAMING_SERVICES_TYPES };
	},
	components: {
		DefaultWidgetField,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		videoSrc() {
			return this.translatePreviousStepsValue(this.fieldOptions.video_player_src);
		},
	},
	methods: {
		translatePreviousStepsValue(value) {
			return this.previousSteps
				? WidgetFormService.processPreviousSteps(
						value,
						this.previousSteps,
						this.replaceInsertDataStringDict,
						this.configurationsMappingBlocksUUIDs
				  )
				: value;
		},
	},
};
</script>

<style scoped lang="scss">
.video-player-field {
	.video-container {
		position: relative;
		width: 100%;
		height: 0;
		padding-bottom: 56.25%;

		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
